import { UserIdentity } from 'types/auth'
import { createAction } from 'utils/redux'

export const receiveIdentityMap = (payload: UserIdentity) => createAction({
  type: 'RECEIVE_IDENTITY_MAP',
  payload
})
